/*
 * Copyright (c) 2024. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React, {useContext} from "react";
import {useTranslation} from "react-i18next";
import {consoleLog} from "utils/utility";
import {ThunkAction} from "redux-thunk";
import BookingAction from "store/booking/BookingAction";
import useNavigation, {RouteName} from "utils/hooks/useNavigation";
import {useDispatch} from "useDispatch";
import {BookingPaidContext} from "pages/Front/Booking/BookingPaid";
import {isResultSuccess} from "utils/paymentUtils";
import Loader from "components/Loader";

const BookingPaidButtons = () => {
    const dispatch = useDispatch();
    const {historyPush} = useNavigation();
    const {t} = useTranslation();
    const bookingPaidContext = useContext(BookingPaidContext);

    const retryHandler = () => {
        if (bookingPaidContext?.packagesCart) {
            dispatch<ThunkAction<any, any, any, any>>(BookingAction.fetchPayCart(bookingPaidContext.packagesCart)).then(r => consoleLog(r.data));
        }
    };

    const finishHandler = () => {
        if (bookingPaidContext?.payment && bookingPaidContext?.packagesCart) {
            dispatch<ThunkAction<any, any, any, any>>(BookingAction.initCart()).then(r => {
                dispatch(BookingAction.clearBookingProcess());
            });
            return historyPush(RouteName.Main, "BookingPaid - finishHandler");
            // props.history.push("/booking");
        }
    };
    if (!bookingPaidContext || !bookingPaidContext.hall) {
        return <Loader />;
    }

    return (
        <div className="BookingPaidButtons flex w-full flex-col items-center">
            {isResultSuccess(bookingPaidContext.payment) && (
                <button
                    className={
                        "hover:opacity-80 bg-cta-800 text-contrast-800 w-full max-w-md cursor-pointer hover:no-underline text-base sm:text-xl flex-grow text-center px-4 py-2 sm:px-5 sm:py-3 flex flex-row justify-center rounded-lg items-center"
                    }
                    onClick={finishHandler}
                >
                    {t("Finish")}
                </button>
            )}
            {!isResultSuccess(bookingPaidContext.payment) && (
                <div className={"w-full flex flex-row justify-between space-x-4 md:space-x-8 m-auto"}>
                    <button
                        className={
                            "hover:opacity-80 bg-cta-800 text-contrast-800 cursor-pointer hover:no-underline text-base sm:text-xl flex-grow text-center px-4 py-2 sm:px-5 sm:py-3 flex flex-row justify-center rounded-lg items-center"
                        }
                        onClick={retryHandler}
                    >
                        {t("Retry")}
                    </button>
                    <button
                        className={
                            "hover:opacity-80 bg-white text-cta-800 cursor-pointer hover:no-underline text-base sm:text-xl flex-grow text-center px-4 py-2 sm:px-5 sm:py-3 flex flex-row justify-center rounded-lg items-center"
                        }
                        onClick={finishHandler}
                    >
                        {t("Cancel")}
                    </button>
                </div>
            )}
            {/*<Dump data={result} />*/}
            {/*Final @todo - chronological rider with all details about arrival, map, venue, guest host contact, etc..*/}
        </div>
    );
};

export default BookingPaidButtons;
